import Swiper, { Pagination, Navigation } from "swiper";

import "swiper/css";
import "swiper/css/pagination";

export default class Slide {
    constructor() {
        this._init();
    }

    _init() {
        this._setSwiper();
        this._setCharaSwiper();
    }

    _setSwiper() {
        [...document.querySelectorAll(".js-swiper")].forEach(($slide) => {
            const opts = {
                modules: [Pagination, Navigation],
                centeredSlides: true,
                slidesPerView: "auto",
                initialSlide: 0,
                speed: 500,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    draggable: true,
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                observer: true,
                observeParents: true,

                breakpoints: {
                    1024: {},
                },
            };

            const swiper = new Swiper($slide, opts);
        });
    }

    _setCharaSwiper() {
        const wrapper = document.querySelector(".js-chswiper");
        const chinfo = document.querySelector(".js-chinfo");
        const chinfo__item = [...document.querySelectorAll(".js-chinfo__item")];

        const opts = {
            modules: [Pagination, Navigation],
            centeredSlides: true,
            loop: true,
            spaceBetween: 0,
            speed: 500,
            slidesPerView: "auto",

            pagination: {
                el: ".swiper-pagination",
                clickable: true,
                draggable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            on: {
                slideChangeTransitionStart: function (swiper) {
                    chinfo__item.forEach((item) => item.classList.remove("-active"));
                },
                slideChangeTransitionEnd: function (swiper) {
                    //swiper.update();
                    chinfo__item[swiper.realIndex].classList.add("-active");
                },
            },
        };

        const swiper = new Swiper(wrapper, opts);
    }
}
